
import { useEffect, useState } from 'react'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import url from '../api/url'
import { elToast } from '../functions/Alerta'

export default function useListadoVacaciones() {


    // variables
    const [listaVacaciones, setListaVacaciones] = useState([])
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [cargando, setCargando] = useState(true)
    const [mostrarAlerta, setMostrarAlerta] = useState(false)
    const [datosModal, setDatosModal] = useState({
        id: 0,
        fecha_propuesta: '',
    })

    // el url del backend
    const { URL: URL_MIO } = url()

    // modal variables
    const [show, setShow] = useState(false);



    // modal functions
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    // functions
    function traerDatos() {

        if (!objLogueado.email) {
            return
        }

        setCargando(true)
        let body = new FormData()
        body.append('email', objLogueado.email)
        body.append('funcion', 'listaVacaciones')

        fetch(URL_MIO, {
            method: 'post',
            body
        })
            .then(a => a.json())
            .then(r => {
                setListaVacaciones(r)

                let a = r.filter( a => a.inicio_vacaciones )

                setMostrarAlerta( a.length > 0 )
            })
            .catch(a => {
                elToast('Hubo un error al cargar su listado de vacaciones', 'error')
            })
            .finally(() => {
                setCargando(false)
            })
    }




    function getYear( fecha ) {
        fecha = new Date(fecha)
        return fecha.getFullYear()
    }


    function borrar( id ) {

        if ( !id ) {
            return
        }

        if (!window.confirm('¿Estas seguro de querer borrar el registro?')) {
            return
        }

        let body = {
            id,
            email: objLogueado.email,
            funcion: 'borrarSolicitud'
        }

        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify( body )
        })
        .then( res => res.json() )
        .then( e => {
            /**
             * 0 = warning
             * 1 = success
             * 2 = error
             */


            // eslint-disable-next-line
            if (e.codigo == 1) {
                elToast( 'Solicitud de vacaciones eliminada', 'success' )
                recargarVacaciones(id)
            // eslint-disable-next-line
            } else if (e.codigo == 0) {
                elToast( e.mensaje, 'info' )
            } else {
                elToast( e.mensaje, 'error' )
            }

        })
        .catch( a => {
            elToast( 'Hay problemas al eliminar esta solicitud', 'error' )
        })


    }

    function recargarVacaciones(id) {

        let n = listaVacaciones.filter( a => a.id !== id )

        setListaVacaciones(n)
    }


    function editar( id ) {

        if ( !id ) {
            return
        }

        let body = {
            id,
            email: objLogueado.email,
            funcion: 'listaVacacionesIndividual'
        }

        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify( body )
        })
        .then( res => res.json() )
        .then( e => {
            setDatosModal( e )
            handleShow()
        })
        .catch( a => {
            elToast( 'Hay problemas al encontrar este registro', 'error' )
        })


    }


    function editarVacaciones() {

        if (datosModal.fecha_propuesta === '0' || datosModal.fecha_propuesta === '') {
            elToast('Debes seleccionar una fecha', 'info')
            return
        }

        let body = {
            ...datosModal,
            email: objLogueado.email,
            funcion: 'actualizarVacaciones'
        }

        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify( body )
        })
        .then( res => res.json() )
        .then( e => {



            // eslint-disable-next-line
            if (e.codigo == 1) {
                elToast( 'Solicitud de vacaciones actualizada', 'success' )
                handleClose()
                // recargarVacaciones(0)

                let aaa = listaVacaciones
                aaa.find( a => a.id === body.id ).fecha_propuesta = body.fecha_propuesta
                setListaVacaciones(aaa)

                setDatosModal({
                    id: 0,
                    fecha_propuesta: '',
                })
                // eslint-disable-next-line
            } else if (e.codigo == 0) {
                elToast( e.mensaje, 'info' )
            } else {
                elToast( e.mensaje, 'error' )
            }

        })
        .catch( a => {
            elToast( 'Hay problemas al actualizar esta solicitud. Intenta iniciar sesión nuevamente.', 'error' )
        })


    }


    // effects
    useEffect(() => {
        traerDatos()

        // eslint-disable-next-line
    }, [])


    return {
        traerDatos, listaVacaciones, getYear, borrar,
        cargando, mostrarAlerta, editar, handleShow, handleClose, show,
        datosModal, setDatosModal, editarVacaciones
    }
}


